












import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { objectIsEmpty } from '~/utils/common.js';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import DateRangeInput from '~/components/inputs/DateRangeInput.vue';

const today = new Date();

@Component({
  components: { ChevronRightSolid, DateRangeInput },
})
export default class ProfileRunsDateFilter extends Vue {
  @Prop(String) label: '';
  @Prop(String) customOpen: '';
  @Prop(Boolean) hideLabel: false;
  @Prop(Object) prefilledRange: {startDate: any, endDate: any};
  @Prop(String) minDate: '';

  $refs: {
    dateFilterButton: HTMLButtonElement
  };

  startDate: any = this.$dayjs(today).hour(0).minute(0).second(0).millisecond(0);
  endDate: any = this.$dayjs(today).hour(23).minute(59).second(59).millisecond(999);
  dateRange: any = {};

  /*
    If a date is preselected and provided from parent, we update datas and emit
    an event to update the style of component on upper levels
  */
  @Watch('prefilledRange')
  handlePrefilled () {
    if (!objectIsEmpty(this.prefilledRange) &&
    this.prefilledRange.endDate &&
    this.prefilledRange.startDate
    ) {
      this.dateRange = this.prefilledRange;
      this.$root.$emit('has-a-prefilled-value');
    }
  }

  mounted () {
    if (process.client) {
      // This condition will remove a hint from range plugin if defined
      if (this.hideLabel) {
        const el: any = document.getElementsByClassName('reportrange-text');
        el.forEach((e: any) => e.classList.add('hidden'));
      }
    }

    // By default we pre-populate this.dateRange to avoid undefined datas in
    // any case
    this.dateRange = { startDate: this.startDate, endDate: this.endDate };

    // The picker can be reset on special contexts where component is too long to
    // be reached from parent-child props system
    this.$root.$on('reset-date-range', () => {
      this.dateRange = { startDate: this.startDate, endDate: this.endDate };
    });
  }
}
